// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"short-ssn_formContainer__waYN_","termsOfService":"short-ssn_termsOfService__A_E8D","buttonContainer":"short-ssn_buttonContainer__CyObF"};